<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <span>Image Viewer</span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div fxLayout="row" fxLayoutAlign="center center">
    <img [src]="data.url" alt="Image Viewer" style="max-width: 100%; max-height: 80vh;" />
  </div>
</mat-dialog-content>
